import { useState } from "react";
import { useSelectionsApi } from "../../hooks/useSelection";
import { ModalFrame } from "../modal-dialog/ModalFrame";

export const NewSelection = (props) => {

    const [newName, setNewName] = useState("");
    const api = useSelectionsApi();

    const createItem = async (pal) => {
        return await api.newItem(pal);
    }

    return <ModalFrame close={props.close}
        title="Create new selection"
        buttons={[
            {
                label: "Create",
                disabled: !newName,
                callback: async () => {
                    const item = {
                        label: newName,
                        //type: newType
                    }
                    setNewName("");
                    const itemInfo = await createItem(item);
                    props?.onNew(itemInfo);
                    props.close();
                }
            },
        ]}
    >
        <div className='form1' style={{ maxWidth: 500 }}>
            <label className="label-line">
                Label:
            </label>
            <div className="value-line">
                <input type="text"
                    autoFocus className='full-width' 
                    placeholder="Enter label for new selection"
                    value={newName}
                    onChange={(ev) => {
                        setNewName(ev.target.value)
                    }}/>
            </div>

            <div className="label-line">
            </div>

        </div>

    </ModalFrame>

    
}


